import React from 'react';
import { StudentForm } from './StudentForm';

const GreenShape: React.FC = () => (
  <div 
    className="w-full h-full bg-black"
    style={{ clipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)' }}
  />
);

export const StudentGreen: React.FC = () => {
  return (
    <StudentForm
      backgroundColor="#DFF37D"
      textColor="black"
      ShapeIcon={GreenShape}
    />
  );
};